import React, { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { Eyebrow as StyledEyebrow } from '../../ContentSystem.shared.styles';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
/**
 * Represents the eyebrow component of the content system.
 *
 * @component
 * @param lightHexCode - The hex code for the light color of the header. Defaults to white.
 * @param children - The content to be rendered inside the eyebrow.
 */
var Eyebrow = function (_a) {
    var lightHexCode = _a.lightHexCode, children = _a.children;
    var typography = useContext(ThemeContext).typography;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return (React.createElement(StyledEyebrow, { lightHexCode: lightHexCode, styleSettings: typography === null || typography === void 0 ? void 0 : typography.eyebrow, "$styleQueryMode": styleQueryMode }, children));
};
export default Eyebrow;
